import { Attr, BelongsTo, Model } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";
import LeagueTable from "./LeagueTable";
import Recruiter from "./Recruiter";

@Model()
class LeagueTableAgency extends ApplicationRecord {
  static jsonapiType = "league_table_agencies";

  @Attr() engagementCount: number;

  @Attr() interviewRate: number;

  @Attr() leagueTableId: number;

  @Attr() origin: string;

  @Attr() placementCount: number;

  @Attr() recruiterId: number;

  @BelongsTo(LeagueTable) leagueTable: LeagueTable;

  @BelongsTo(Recruiter) recruiter: Recruiter;
}

export default LeagueTableAgency;
